import { get } from "@/lib/api-client-v2";

export type GarSuggestItem = {
  gar_uuid: string;
  formatted_address: string;
  level?: number | null;
  is_house?: boolean;
  latitude?: number | null;
  longitude?: number | null;
};

export type GarSuggestResponse = {
  items: GarSuggestItem[];
  registry_ready: boolean;
};

export async function suggestGarAddresses(
  q: string,
  limit = 8
): Promise<GarSuggestResponse> {
  return get<GarSuggestResponse>("/gar/suggest", { q, limit });
}
